"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var area = ui_blocks_1.INTERACTIVE.area;
var captionMedium = ui_blocks_1.TYPOGRAPHY.captionMedium;
exports.Table = styled_components_1.default.table(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  border-collapse: separate;\n  border-spacing: 0;\n\n  &:focus:not(:focus-visible)::before {\n    z-index: 0;\n  }\n\n  & abbr[title] {\n    ", "\n    text-decoration: none;\n  }\n\n  & thead {\n    cursor: default;\n  }\n\n  & th {\n    padding: 0;\n  }\n\n  & thead,\n  & tbody,\n  & tfooter {\n    position: relative;\n    z-index: 10;\n  }\n"], ["\n  ", "\n  border-collapse: separate;\n  border-spacing: 0;\n\n  &:focus:not(:focus-visible)::before {\n    z-index: 0;\n  }\n\n  & abbr[title] {\n    ", "\n    text-decoration: none;\n  }\n\n  & thead {\n    cursor: default;\n  }\n\n  & th {\n    padding: 0;\n  }\n\n  & thead,\n  & tbody,\n  & tfooter {\n    position: relative;\n    z-index: 10;\n  }\n"])), area, captionMedium);
var templateObject_1;